import { useState, useCallback } from "react";
import { CommonType } from "../../types";
import { getParserConfigPaginate } from "../../services/parserConfigService";
import { getConnectionTypeList } from "../../services/connectionTypeService";
import { usePaginatedData } from "../../hooks/usePaginatedData";
import { fetchListOrThrow } from "../../utils/fetchList";

export const useParserConfigData = (deviceTypeId: number) => {
  const [connectionType, setConnectionType] = useState<CommonType[]>([]);

  const fetchFn = useCallback(
    (page: number, pageSize: number, filter: string) =>
      getParserConfigPaginate({ page, pageSize, filter, deviceTypeId }),
    [deviceTypeId]
  );

  const paginated = usePaginatedData<CommonType>(fetchFn, [deviceTypeId]);

  const fetchConnectionType = () => fetchListOrThrow(getConnectionTypeList, setConnectionType);

  return { ...paginated, connectionType, fetchConnectionType };
};
